import { loadedLibrary } from 'actions/global';

import { getApartment } from 'actions/apartment';
import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import { loadGoogleMapLibrary } from 'util/script';

export default store => ({
	path: 'map',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'Map',
				),
			store,
			'MAP',
		),
		onEnter: withAsyncEnterLoader(
			async (_, __, updateRatio) => {
				updateRatio(0.3);

				await loadGoogleMapLibrary();
				store.dispatch(loadedLibrary('googleMap'));

				await store.dispatch(getApartment());
				updateRatio(0.8);
			},
			store,
			'ENTER_MAP',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Map/index.js